// Module
var code = "<div class=\"mx-shell-avatar\" ng-class=\"{'mx-shell-avatar--dark': vm.isDark }\">\r\n\t<div class=\"mx-shell-avatar__image\" ng-style=\"{'background-image': vm.photoCss}\" title=\"{{:: vm.name}} {{:: vm.surname}}\">\r\n\t\t{{:: vm.alternativeAbbreviation}}\r\n\t</div>\r\n</div>\r\n";
// Exports
export default code;